import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import FileCopyIcon from '@material-ui/icons/FileCopy'

import AsterButton from 'asterX-UIkit/Buttons/AsterButton'
import AsterChip from 'asterX-UIkit/Chips/AsterChip'
import AsterPagination from 'asterX-UIkit/Pagination/AsterPagination'
import { primaryB } from 'asterX-UIkit/constants/colors'

import * as status from 'constants/statuses'

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    height: '100%'
  }
})
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

const DataTableWithPagination = ({
  page: { page, setPage },
  totalElements,
  columns,
  rows,
  editAction,
  copyAction
}) => {
  const classes = useStyles()

  const handleChangePage = (_, newPage) => setPage(newPage)

  const statusConfig = {
    [status.NEW_STATUS]: '#E9F2FF',
    [status.IN_PROGRESS_STATUS]: '#0B6EC7',
    [status.NEED_REVISION_STATUS]: '#F7D117',
    [status.EXECUTED_STATUS]: '#4BAB43',
    [status.DECLINED_STATUS]: '#B1BBC7'
  }

  const statusColor = {
    [status.NEW_STATUS]: '#0B6EC7',
    [status.IN_PROGRESS_STATUS]: '#ffffff',
    [status.NEED_REVISION_STATUS]: '#000000',
    [status.EXECUTED_STATUS]: '#ffffff',
    [status.DECLINED_STATUS]: '#000000'
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <StyledTableCell key={column.id}>
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map(row => {
              return (
                <StyledTableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.code}
                >
                  {columns.map(column => {
                    const value = row[column.id]

                    return (
                      <>
                        {column.id !== 'copyAction' ? (
                          column.id === 'status' ? (
                            <StyledTableCell key={column.id}>
                              <AsterChip
                                label={value}
                                style={{
                                  backgroundColor: statusConfig[value],
                                  color: statusColor[value]
                                }}
                              />
                            </StyledTableCell>
                          ) : (
                            <StyledTableCell
                              key={column.id}
                              onClick={() => editAction(row.id)}
                            >
                              {column.format ? column.format(value) : value}
                            </StyledTableCell>
                          )
                        ) : (
                          <TableCell key={column.id}>
                            {row['status'] === status.DECLINED_STATUS && (
                              <AsterButton onClick={() => copyAction(row.id)}>
                                <FileCopyIcon style={{ color: primaryB }} />
                              </AsterButton>
                            )}
                          </TableCell>
                        )}
                      </>
                    )
                  })}
                </StyledTableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <AsterPagination
        size="large"
        page={page}
        count={Math.ceil(totalElements / 30)}
        onChange={handleChangePage}
      />
    </Paper>
  )
}
export default DataTableWithPagination
